export const RESET_SETTINGS = 'RESET_SETTINGS';
export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const LOAD_EXCHANGE_INFO = 'LOAD_EXCHANGE_INFO';
export const LOAD_STATS = 'LOAD_STATS';
export const LOAD_ACTIONS_STATS = 'LOAD_ACTIONS_STATS';
